import { post } from '@webapp-next/lib/request/webapp/http';

export default async function areasGet(locationIds = [], association = []) {
  const body = {
    start: 0,
    sort: {
      OperationalUnitName: 'asc',
    },
    assoc: association,
    // max: 50,
  };

  if (locationIds.length > 0) {
    body.search = {
      OperationalUnitName1: {
        field: 'Company',
        type: 'in',
        data: locationIds,
      },
    };
  }

  const options = {
    headers: {
      'dp-meta-option': 'none',
    },
  };

  try {
    const { data } = await post(
      '/api/v1/resource/OperationalUnit/QUERY',
      body,
      options
    );

    return {
      success: true,
      message: '',
      data: data || [],
    };
  } catch (e) {
    console.error(e);
    throw e;
  }
}
